import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * This function returns the translation key for the given state.
 * @param state
 * @returns
 */
export function getStateTranslationKey(
	state: Enums<"state"> | Enums<"absenceState"> | "expired",
): TranslationKey {
	switch (state) {
		case "active":
			return "general.active";
		case "inactive":
			return "general.inactive";
		case "pending":
			return "general.pending";
		case "approved":
			return "general.approved";
		case "rejected":
			return "absences.state.rejected";
		case "cancelled":
			return "absences.state.cancelled";
		case "expired":
			return "substitutions.is_expired";
	}
}
